import {ReactSVG} from 'react-svg';
/**
 * Cuộn mượt đến phần tử có ID được chỉ định.
 * @param {string} id - ID của phần tử HTML cần cuộn đến.
 * @param {ScrollLogicalPosition} [block='start'] - Căn chỉnh dọc ('start', 'center', 'end', 'nearest'). Mặc định là 'start'.
 * @param {ScrollLogicalPosition} [inline='nearest'] - Căn chỉnh ngang ('start', 'center', 'end', 'nearest'). Mặc định là 'nearest'.
 */
export const smoothScrollToId = (id, block = 'start', inline = 'nearest', navigate) => {

    console.log(`Attempting to scroll to element with ID: ${id}`);
    const element = document.getElementById(id);

    if (element) {
        element.scrollIntoView({
            behavior: 'smooth',
            block: block,
            inline: inline,
        });
        console.log(`Successfully found and scrolled to element:`, element);
    } else {
        try {
            console.log(`Element with ID "${id}" not found. Redirecting to home and attempting scroll.`);

            // Redirect về trang chủ
            navigate('/');

            // Sử dụng setTimeout để đảm bảo trang chủ đã render trước khi scroll
            setTimeout(() => {
                const elementAfterRedirect = document.getElementById(id);
                if (elementAfterRedirect) {
                    elementAfterRedirect.scrollIntoView({
                        behavior: 'smooth',
                        block: block,
                        inline: inline,
                    });
                    console.log(`Successfully found and scrolled to element after redirect:`, elementAfterRedirect);
                } else {
                    console.error(`Element with ID "${id}" still not found after redirect.`)
                }
            }, 500); // Chờ 500ms (có thể điều chỉnh nếu cần)
        } catch (error) {
            console.log(error, "error")
        }
    }
};

export const getIcon = (key) => {
    switch (key) {
        case "address":
            return <ReactSVG src="assets/icons/svg/address.svg"/>
        case "clock":
            return <ReactSVG src="assets/icons/svg/clock.svg"/>
        case "phone":
            return <ReactSVG src="assets/icons/svg/phone.svg"/>
        case "mail":
            return <ReactSVG src="assets/icons/svg/mail.svg"/>
        case "prev":
            return <ReactSVG src="assets/icons/svg/prev.svg"/>
        case "next":
            return <ReactSVG src="assets/icons/svg/next.svg"/>
        case "calendar":
            return <ReactSVG src="assets/icons/svg/calendar.svg"/>
        case "drop-down":
            return <ReactSVG src="assets/icons/svg/drop-down.svg"/>
        case "person":
            return <ReactSVG src="assets/icons/svg/person.svg"/>
        case "separator":
            return <ReactSVG src="assets/icons/svg/separator.svg"/>
        case "close":
            return <ReactSVG src="assets/icons/svg/close.svg"/>
        default:
            return;

    }
}